<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <ServicePageCover />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex>
        <ServicePageList />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import ServicePageCover from "./servicePage1";
import ServicePageList from "./servicePage2";
export default {
  components: {
    ServicePageCover,
    ServicePageList,
  },

  data() {
    return {};
  },
};
</script>